<lib-card>
  <ng-container title>Offerta Economica</ng-container>
  <ng-container content>
    @if (economicOffer(); as offer) {
      <div class="flex flex-col gap-6 pt-4">
        <div class="flex items-center gap-4">
          <div class="flex items-center gap-2">
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >PEF richiesto:</span
            >
            <span
              class="rounded-full px-3 py-1 text-sm font-bold uppercase"
              [class]="
                offer.isRequired
                  ? 'bg-slate-100 text-slate-700'
                  : 'bg-slate-50 text-slate-400'
              "
            >
              {{ offer.isRequired ? 'Sì' : 'No' }}
            </span>
          </div>
          <div class="flex items-center gap-2">
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >PEF presentato:</span
            >
            <span
              class="rounded-full px-3 py-1 text-sm font-bold uppercase"
              [class]="
                offer.isPresent
                  ? 'bg-green-100 text-green-700'
                  : 'bg-red-100 text-red-700'
              "
            >
              {{ offer.isPresent ? 'Sì' : 'No' }}
            </span>
          </div>
        </div>

        @if (
          offer.score !== null &&
          offer.score !== undefined &&
          offer.maxScore !== null &&
          offer.maxScore !== undefined
        ) {
          <div
            class="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
          >
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >Punteggio:</span
            >
            <span class="text-xl font-bold text-slate-800">
              {{ offer.score | number: '1.1-1' }} / {{ offer.maxScore }} pt
            </span>
            @if (scorePercent() !== null) {
              <span
                class="rounded-full px-2.5 py-0.5 text-sm font-bold"
                [class]="scoreBadgeClass()"
              >
                {{ scorePercent() | number: '1.0-0' }}%
              </span>
            }
          </div>
        }

        @if (offer.description) {
          <p class="text-base leading-relaxed text-slate-600">
            {{ offer.description }}
          </p>
        }

        @if (offer.keyMetrics.length) {
          <div class="flex flex-col gap-3">
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >Indicatori chiave</span
            >
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
              @for (metric of offer.keyMetrics; track $index) {
                <div
                  class="flex flex-col gap-1 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
                >
                  <span
                    class="text-sm font-semibold uppercase tracking-wide text-slate-400"
                    >{{ metric.name }}</span
                  >
                  <span class="text-md font-bold text-slate-800">{{
                    metric.value
                  }}</span>
                  @if (metric.notes) {
                    <span class="text-sm text-slate-500">{{
                      metric.notes
                    }}</span>
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (offer.validationIssues.length) {
          <div class="flex flex-col gap-3">
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >Problemi di validazione</span
            >
            <div class="flex flex-col gap-2">
              @for (issue of offer.validationIssues; track $index) {
                <ng-container
                  *ngTemplateOutlet="issueItem; context: { $implicit: issue }"
                ></ng-container>
              }
            </div>
          </div>
        }

        @if (offer.coherenceIssues.length) {
          <div class="flex flex-col gap-3">
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >Problemi di coerenza</span
            >
            <div class="flex flex-col gap-2">
              @for (issue of offer.coherenceIssues; track $index) {
                <ng-container
                  *ngTemplateOutlet="issueItem; context: { $implicit: issue }"
                ></ng-container>
              }
            </div>
          </div>
        }
      </div>
    }
  </ng-container>
</lib-card>

<ng-template #issueItem let-issue>
  <div
    class="flex flex-col gap-1 rounded-xl border-l-4 bg-slate-50 px-4 py-3"
    [class]="
      issue.severity === 'High'
        ? 'border-red-500'
        : issue.severity === 'Medium'
          ? 'border-yellow-400'
          : 'border-blue-400'
    "
  >
    <div class="flex items-start justify-between gap-3">
      <span class="text-md font-semibold text-slate-800">{{
        issue.title
      }}</span>
      <span
        class="shrink-0 rounded-full px-2.5 py-0.5 text-sm font-bold uppercase"
        [class]="
          issue.severity === 'High'
            ? 'bg-red-100 text-red-700'
            : issue.severity === 'Medium'
              ? 'bg-yellow-100 text-yellow-700'
              : 'bg-blue-100 text-blue-700'
        "
      >
        {{ issue.severity }}
      </span>
    </div>
    <p class="m-0 text-sm leading-snug text-slate-600">{{ issue.details }}</p>
  </div>
</ng-template>
